
















































import {
  Component,
  Vue,
  Prop,
  Watch,
} from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import SearchBar from '@/components/SearchBar.vue';
import Drawer from '@/components/Drawer.vue';
import FileUpload from '@/components/FileUpload.vue';
import List from '@/components/List.vue';
import AdminDeviceTypeService from '@/services/admin.devicetype.service';
import AltSpinner from '../../components/AltSpinner.vue';
import Table from '@/components/Table.vue';

@Component({
  components: {
    SearchBar,
    Table,
    Drawer,
    FileUpload,
    List,
    AltSpinner,
  },
})
export default class DeviceTypes extends Vue {
  private key: number = 1;
  private showAddDeviceTypeDrawerBoolean: boolean = false;
  private devicesSelected: number[] = [];
  private deviceTypes: any[] = [];
  private options: any = { itemsPerPage: 25 };
  private search: string = '';
  @Getter private activeOrganisation: any;
  @Action private addToastErrorMessage: any;
  @Getter private activeProjectId!: number;


  private tableData: any = {
    headers: [
      {text: 'Device Type ID', value: 'id', align: 'start', filterable: true},
      {text: 'Manufacturer', value: 'manufacturer', filterable: true},
      {text: 'Model', value: 'model', filterable: true},
      {text: 'Name', value: 'name', filterable: true},
      {text: 'Slug', value: 'slug', filterable: true},
      {text: 'Bearer', value: 'bearer', filterable: true},
      {text: 'Status', value: 'status', filterable: true},
      {text: '', value: 'actions', filterable: false, sortable: false},
    ],
    total: 0,
    filters: {},
    distinctRows: {},
  };

  private async mounted() {
    await this.getAllDeviceTypes();
  }

  private incrementKey() {
    if (this.key >= 1000) {
      this.key = 0;
    } else {
      this.key++;
    }
  }


  private async addDeviceType() {
    this.$router.push('/admin/settings/deviceType/new');
  }

  private async getAllDeviceTypes() {
    this.deviceTypes = await AdminDeviceTypeService.getSystemDeviceTypes();
    this.populateDeviceTypes();
  }

  private populateDeviceTypes() {
    if (!this.tableData.rows) {
      const rows: any[] = [];
      const data = this.deviceTypes;
      data.map((row: any) => {
        rows.push({
          id: row.id,
          path: `/admin/settings/deviceType/${row.id}`,
          manufacturer: row.device_model.manufacturer.name,
          model: row.device_model.name,
          name: row.name,
          slug: row.slug,
          status: row.status,
          bearer: row.bearer,
        });
      });
      Vue.set(this.tableData, 'rows', rows);
    }
  }

  private goToEdit(row: any) {
    if (row.path) {
      this.$router.push({ path: row.path });
    }
  }
}
